(function(){
    angular
        .module('appback')
        .directive('ngInfopeti', extrapeti);

        extrapeti.$inject = ['$timeout'];
        function extrapeti($timeout){
            return {
            	//restrict:'E',
		        scope: {
		          	item:'=',
		          	muestra:"=",
		          	extra:"="
	            },
	           	template: '<div ng-include="getTemplateUrl()"></div>',

	            /*templateUrl: function(element,$attrs){
	            	console.log($attrs);
	            	return '/uranolab/extrapeti?lang_id='+lang_id+"&form="+$attrs.formulario+"[[formulario]]";
	            },*/
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	console.log("infopet");
		            	scope.getTemplateUrl = function () {
	            			return '/backend/resultadopeticion/infoextra?name='+scope.item.analitica.formulario.toLowerCase()+".twig";
			            }
		            });
		        }
          }
      	}
})();